import React from "react";
import ReactPaginate from "react-paginate";
import useIsMobileScreen from "@qlik/qlik/src/hooks/useIsMobileScreen";

const paginationContainerClassName = "flex flex-row justify-center gap-2.5 mx-auto pt-20 lg:pt-20 pb-5";
const pagePageCommonClassName = "relative w-12 h-12 md:w-15 md:h-15 rounded-full";
const pageLinkClassName = `${pagePageCommonClassName} flex justify-center items-center border font-medium border-stone text-stone hover:no-underline lg:hover:text-white lg:hover:bg-green lg:hover:border-green`;
const pageLinkActiveClassName = `${pageLinkClassName} text-white border-0 border-green border-1 bg-green`;
const pageClassName = "list-none after:content-[] pl-0";
const pageArrowClassName = `${pagePageCommonClassName} block border-2 border-green lg:hover:bg-green lg:hover:border-green group/arrow`;
const pageDisabledClassName = "pointer-events-none opacity-30 ";

const PaginationJump = ({ isNext }) => (
    <span
        className={`block relative top-1/2 -translate-y-1/2 mx-auto w-2.25 h-3.5 slick-arrow-right lg:group-hover/arrow:brightness-0 lg:group-hover/arrow:invert ${
            isNext ? "rotate-0" : "slick-arrow-left"
        }`}
    />
);

/**
 * Pagination component for handling page navigation.
 *
 * @component
 * @param {Object} props - The properties passed to the component.
 * @param {number} props.currentPage - The current active page.
 * @param {number} props.limit - The maximum number of items per page.
 * @param {number} props.total - The total number of items.
 * @param {function} props.handlePageChange - The function to call when a page link is clicked.
 *
 * @returns {JSX.Element} The Pagination component.
 */
const Pagination = ({ currentPage, limit, total, handlePageChange }) => {
    // construct pagination links
    const numberOfPages = Math.ceil(total / limit);
    const isMobileScreen = useIsMobileScreen();

    if (numberOfPages <= 1) return null;

    return (
        <ReactPaginate
            breakLabel={isMobileScreen ? null : "..."}
            nextLabel={<PaginationJump isNext />}
            previousLabel={<PaginationJump />}
            forcePage={currentPage}
            onPageChange={(page) => handlePageChange(page.selected)}
            pageRangeDisplayed={isMobileScreen ? 1 : 3}
            pageCount={numberOfPages}
            marginPagesDisplayed={isMobileScreen ? 0 : 1}
            renderOnZeroPageCount={null}
            containerClassName={paginationContainerClassName}
            pageClassName={pageClassName}
            pageLinkClassName={pageLinkClassName}
            activeLinkClassName={pageLinkActiveClassName}
            breakClassName={pageClassName}
            breakLinkClassName={pageLinkClassName}
            previousClassName={pageClassName}
            nextClassName={pageClassName}
            previousLinkClassName={`${pageArrowClassName} mr-3 md:mr-5`}
            nextLinkClassName={`${pageArrowClassName} ml-3 md:ml-5`}
            disabledClassName={pageDisabledClassName}
        />
    );
};

export default Pagination;
